var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "justify-content-center" },
    [
      _c("b-col", { staticClass: "mt-3", attrs: { cols: "12" } }, [
        _c(
          "div",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass: "d-flex justify-content-end mt-3",
                    attrs: { cols: "12" },
                  },
                  [
                    _c("b-button", { staticClass: "btnFilter_2" }, [
                      _c("i", { staticClass: "fa-light fa-upload" }),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("mandate.upload_signed_mandate")) +
                          "\n      "
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.type !== "dbtr"
              ? _c(
                  "form-accordion",
                  {
                    attrs: {
                      title: _vm.$t("mandate.mandate_info"),
                      isTitleUpperCase: false,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-top": "1.5rem",
                          "padding-bottom": "1.5rem",
                        },
                      },
                      [
                        _c(
                          "b-row",
                          { staticClass: "ml-0 mb-4 mr-5 form-group" },
                          [
                            _c("b-col", { attrs: { sm: "5" } }, [
                              _c("label", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("mandate.schema")) +
                                    " "
                                ),
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.active_schema,
                                      expression: "active_schema",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "sel4",
                                    disabled: _vm.isDisabled,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.active_schema = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "core" } }, [
                                    _vm._v(_vm._s(_vm.$t("mandate.core"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "b2b" } }, [
                                    _vm._v(_vm._s(_vm.$t("mandate.b2b"))),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("b-col", { attrs: { sm: "5" } }, [
                              _c("label", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("mandate.tx_type")) +
                                    " "
                                ),
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.active,
                                      expression: "active",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "sel4",
                                    disabled: _vm.isDisabled,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.active = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "one_off" } },
                                    [_vm._v(_vm._s(_vm.$t("mandate.one_off")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "recurrent" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("mandate.recurrent"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "ml-0 mt-2 mb-4 mr-5 form-group" },
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "5" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t(
                                      "mandate.underlying_contract_id"
                                    ),
                                    disabled: _vm.isDisabled,
                                  },
                                  model: {
                                    value: _vm.ctr,
                                    callback: function ($$v) {
                                      _vm.ctr = $$v
                                    },
                                    expression: "ctr",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.showUmrControls
                              ? _c(
                                  "b-col",
                                  { attrs: { sm: "5" } },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "ml-1 form-group" },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "d-block mb-2" },
                                          [_vm._v("Unique Mandate References")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      {
                                        staticClass:
                                          "ml-2 mt-4 mb-4 mr-5 form-group",
                                      },
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { sm: "1" } },
                                          [
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  id: "umrAuto",
                                                  checked: _vm.umrAutoChecked,
                                                },
                                                on: {
                                                  change: _vm.onUmrAutoChange,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "mandate.umr_auto"
                                                      ) ||
                                                        "Gérer automatiquement"
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { sm: "6" } },
                                          [
                                            _c(
                                              "b-row",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "b-form-checkbox",
                                                  {
                                                    staticClass: "ml-2",
                                                    attrs: {
                                                      id: "umrManual",
                                                      checked:
                                                        _vm.umrManualChecked,
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.onUmrManualChange,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "mandate.umr_manual"
                                                          ) || "Manuelle"
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.umrManualChecked
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "ml-4 mt-3",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.umrManual,
                                                              expression:
                                                                "umrManual",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text",
                                                            placeholder:
                                                              _vm.$t(
                                                                "mandate.umr_placeholder"
                                                              ) ||
                                                              "Saisir le UMR…",
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.umrManual,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.umrManual =
                                                                $event.target.value
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "ml-0 mb-4 mr-5 form-group" },
                          [
                            _c("b-col", { attrs: { sm: "5" } }, [
                              _c(
                                "label",
                                { attrs: { for: "mandate-language" } },
                                [
                                  _vm._v(
                                    "  " +
                                      _vm._s(_vm.$t("mandate.langue_mandat")) +
                                      " "
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.mandateLang,
                                      expression: "mandateLang",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "mandate-language",
                                    disabled: _vm.isDisabled,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.mandateLang = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                _vm._l(
                                  _vm.mandateLanguageOptions,
                                  function (opt) {
                                    return _c(
                                      "option",
                                      {
                                        key: opt.value,
                                        domProps: { value: opt.value },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(opt.label) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "dbtr"
              ? _c(
                  "form-accordion",
                  {
                    attrs: {
                      title: _vm.$t("mandate.mandate_info"),
                      isTitleUpperCase: false,
                    },
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "ml-0 mt-4 mb-4 mr-5 form-group" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _c("form-read-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t(
                                  "mandate.underlying_contract_id"
                                ),
                                inputValue: _vm.ctr,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _c("form-read-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t("mandate.tx_type"),
                                inputValue: _vm.$t("mandate." + _vm.active),
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "form-accordion",
              {
                attrs: {
                  title: _vm.$t("mandate.cdtr_info"),
                  isTitleUpperCase: false,
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-top": "1.5rem",
                      "padding-bottom": "1.5rem",
                    },
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "ml-0 mb-4 mr-5 form-group" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _vm.type !== "dbtr"
                              ? _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("mandate.cdtr_name"),
                                    isMandatory: "",
                                  },
                                  model: {
                                    value: _vm.cdtr_name,
                                    callback: function ($$v) {
                                      _vm.cdtr_name = $$v
                                    },
                                    expression: "cdtr_name",
                                  },
                                })
                              : _c("form-read-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("mandate.cdtr_name"),
                                    inputValue: _vm.cdtr_name,
                                  },
                                }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _vm.type !== "dbtr"
                              ? _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("mandate.cdtr_id"),
                                    isMandatory: "",
                                  },
                                  model: {
                                    value: _vm.cdtr_id,
                                    callback: function ($$v) {
                                      _vm.cdtr_id = $$v
                                    },
                                    expression: "cdtr_id",
                                  },
                                })
                              : _c("form-read-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("mandate.cdtr_id"),
                                    inputValue: _vm.cdtr_id,
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "ml-0 mt-2 mb-4 mr-5 form-group" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel:
                                  _vm.$t("mandate.cdtr_ref_name") ||
                                  "Creditor reference name",
                              },
                              model: {
                                value: _vm.cdtr_ref_name,
                                callback: function ($$v) {
                                  _vm.cdtr_ref_name = $$v
                                },
                                expression: "cdtr_ref_name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel:
                                  _vm.$t("mandate.cdtr_ref_id") ||
                                  "Creditor reference ID",
                              },
                              model: {
                                value: _vm.cdtr_ref_id,
                                callback: function ($$v) {
                                  _vm.cdtr_ref_id = $$v
                                },
                                expression: "cdtr_ref_id",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "ml-0 mb-4 mr-5 form-group" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _vm.type !== "dbtr"
                              ? _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("mandate.cdtr_addrss"),
                                  },
                                  model: {
                                    value: _vm.cdtr_addrss,
                                    callback: function ($$v) {
                                      _vm.cdtr_addrss = $$v
                                    },
                                    expression: "cdtr_addrss",
                                  },
                                })
                              : _c("form-read-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("mandate.cdtr_addrss"),
                                    inputValue: _vm.cdtr_addrss,
                                  },
                                }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _vm.type !== "dbtr"
                              ? _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("mandate.cdtr_city"),
                                  },
                                  model: {
                                    value: _vm.cdtr_city,
                                    callback: function ($$v) {
                                      _vm.cdtr_city = $$v
                                    },
                                    expression: "cdtr_city",
                                  },
                                })
                              : _c("form-read-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("mandate.cdtr_city"),
                                    inputValue: _vm.cdtr_city,
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      {
                        staticClass: "ml-0 mr-5 form-group",
                        staticStyle: { "margin-bottom": "1.5rem" },
                      },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _vm.type !== "dbtr"
                              ? _c("div", [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("mandate.cdtr_ctry"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.cdtr_ctry,
                                          expression: "cdtr_ctry",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.cdtr_ctry = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          _vm.onCountryChange,
                                        ],
                                      },
                                    },
                                    _vm._l(_vm.countryOptions, function (opt) {
                                      return _c(
                                        "option",
                                        {
                                          key: opt.value,
                                          domProps: { value: opt.value },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("countries." + opt.key)
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ])
                              : _c("form-read-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("mandate.cdtr_ctry"),
                                    inputValue: _vm.cdtr_ctry,
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _vm.type !== "dbtr"
              ? _c(
                  "form-accordion",
                  {
                    attrs: {
                      title: _vm.$t("mandate.dbtr_info"),
                      isTitleUpperCase: false,
                    },
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "ml-0 mt-4 mb-4 mr-5 form-group" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t("mandate.dbtr_email"),
                                isMandatory: "",
                              },
                              model: {
                                value: _vm.dbtr_email,
                                callback: function ($$v) {
                                  _vm.dbtr_email = $$v
                                },
                                expression: "dbtr_email",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t("mandate.dbtr_name"),
                                isMandatory: "",
                              },
                              model: {
                                value: _vm.dbtr_name,
                                callback: function ($$v) {
                                  _vm.dbtr_name = $$v
                                },
                                expression: "dbtr_name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "ml-0 mt-4 mb-4 mr-5 form-group" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t("mandate.dbtr_addr"),
                                isMandatory: "",
                              },
                              model: {
                                value: _vm.dbtr_addr,
                                callback: function ($$v) {
                                  _vm.dbtr_addr = $$v
                                },
                                expression: "dbtr_addr",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t("mandate.dbtr_city"),
                                isMandatory: "",
                              },
                              model: {
                                value: _vm.dbtr_city,
                                callback: function ($$v) {
                                  _vm.dbtr_city = $$v
                                },
                                expression: "dbtr_city",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "ml-0 mt-4 mb-4 mr-5 form-group" },
                      [
                        _c("b-col", { attrs: { sm: "5" } }, [
                          _c("label", { staticClass: "font-weight-bold" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("mandate.dbtr_ctry")) +
                                "\n              "
                            ),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("*"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.dbtr_ctry,
                                  expression: "dbtr_ctry",
                                },
                              ],
                              staticClass: "form-control",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.dbtr_ctry = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            _vm._l(_vm.countryOptions, function (opt) {
                              return _c(
                                "option",
                                {
                                  key: "dbtr-" + opt.value,
                                  domProps: { value: opt.value },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("countries." + opt.key)) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                value: _vm.dbtr_phone,
                                inputLabel: _vm.$t("mandate.dbtr_phone"),
                                isMandatory: "",
                              },
                              on: { input: _vm.onPhoneInput },
                            }),
                            _vm._v(" "),
                            _vm.dbtr_phone
                              ? _c(
                                  "small",
                                  {
                                    staticClass: "d-block mt-1",
                                    class: _vm.isValidEuropeanPhone(
                                      _vm.dbtr_phone
                                    )
                                      ? "text-muted"
                                      : "text-danger",
                                  },
                                  [
                                    _vm.isValidEuropeanPhone(_vm.dbtr_phone)
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("mandate.phone_valid")
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("mandate.phone_invalid")
                                              ) +
                                              "\n              "
                                          ),
                                        ],
                                  ],
                                  2
                                )
                              : _c(
                                  "small",
                                  { staticClass: "text-muted d-block mt-1" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("mandate.phone_hint")) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "ml-0 mt-4 mb-4 mr-5 form-group" },
                      [
                        _c("b-col", { attrs: { sm: "5" } }, [
                          _c(
                            "label",
                            { staticClass: "font-weight-bold mb-3" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("mandate.signature_mode")) +
                                  "\n              "
                              ),
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("*"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "b-form-radio",
                                {
                                  staticClass: "mb-2",
                                  attrs: {
                                    name: "signature-mode",
                                    value: "docusign",
                                  },
                                  model: {
                                    value: _vm.signatureMode,
                                    callback: function ($$v) {
                                      _vm.signatureMode = $$v
                                    },
                                    expression: "signatureMode",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("mandate.signature_docusign")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.signatureMode === "docusign" &&
                              _vm.showDocusignMode
                                ? _c(
                                    "div",
                                    { staticClass: "ml-4 mt-2 mb-3" },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          staticClass: "mb-2",
                                          attrs: {
                                            name: "docusign-mode",
                                            value: "url",
                                          },
                                          model: {
                                            value: _vm.docusignMode,
                                            callback: function ($$v) {
                                              _vm.docusignMode = $$v
                                            },
                                            expression: "docusignMode",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  URL\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-form-radio",
                                {
                                  attrs: {
                                    name: "signature-mode",
                                    value: "openwens",
                                  },
                                  model: {
                                    value: _vm.signatureMode,
                                    callback: function ($$v) {
                                      _vm.signatureMode = $$v
                                    },
                                    expression: "signatureMode",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("mandate.Powens")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "mb-5", attrs: { sm: "5" } },
                          [
                            _c("iban-input", {
                              ref: "dbtrIbanInput",
                              attrs: {
                                label: _vm.$t("mandate.dbtr_iban"),
                                required: false,
                                hint: _vm.$t("mandate.iban_hint") || "",
                              },
                              model: {
                                value: _vm.dbtr_iban,
                                callback: function ($$v) {
                                  _vm.dbtr_iban = $$v
                                },
                                expression: "dbtr_iban",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "dbtr"
              ? _c(
                  "form-accordion",
                  {
                    attrs: {
                      title: _vm.$t("mandate.dbtr_info"),
                      isTitleUpperCase: false,
                    },
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "ml-0 mt-4 mb-4 mr-5 form-group" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t("mandate.dbtr_name"),
                                isMandatory: "",
                              },
                              model: {
                                value: _vm.dbtr_name,
                                callback: function ($$v) {
                                  _vm.dbtr_name = $$v
                                },
                                expression: "dbtr_name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "5" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t("mandate.dbtr_iban"),
                              },
                              model: {
                                value: _vm.dbtr_iban,
                                callback: function ($$v) {
                                  _vm.dbtr_iban = $$v
                                },
                                expression: "dbtr_iban",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.type !== "dbtr"
              ? _c(
                  "b-row",
                  { staticClass: "form-group justify-content-end" },
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "2" } },
                      [
                        !_vm.isSubmitting
                          ? _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "primary",
                                  disabled:
                                    !_vm.isFormValid || _vm.isSubmitting,
                                },
                                on: { click: _vm.onSend },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-light fa-paper-plane",
                                  attrs: { size: "17px" },
                                }),
                                _vm._v(" "),
                                !_vm.isSubmitting
                                  ? _c("span", [
                                      _vm._v(_vm._s(_vm.$t("mandate.send"))),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("common.sending") || "Envoi…"
                                        )
                                      ),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "dbtr"
              ? _c(
                  "b-row",
                  { staticClass: "form-group justify-content-end" },
                  [
                    _c(
                      "b-col",
                      { attrs: { lg: "2", "offset-lg": "8" } },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "primary", size: "lg" },
                            on: { click: _vm.editProfile },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("mandate.accept"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "2" } },
                      [
                        _c("b-button", { attrs: { variant: "primary" } }, [
                          _c("span", [_vm._v(_vm._s(_vm.$t("mandate.refus")))]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }